<template>
  <div id="chat">
    <Loader />
    <div class="chat" v-if="authState === 'loggedIn'">
      <Header @close="closeChat" />
      <Body :messages="getMessages" />
      <MessageHints />
      <Footer @send="sendMessage" />
    </div>
    <Authorization v-if="authState === 'loggedOut'" />
  </div>
</template>

<script>
import Loader from './elements/Loader'
import Header from './partials/Header'
import Body from './partials/Body'
import Authorization from './partials/Authorization'
import Footer from './partials/Footer'
import { mapActions, mapGetters } from 'vuex'
import MessageHints from './elements/MessageHints.vue'

export default {
  name: 'Chat',
  components: {
    Loader,
    Header,
    Body,
    Authorization,
    Footer,
    MessageHints
  },
  computed: {
    ...mapGetters({
      getMessages: 'messages/getMessages',
      authState: 'chat/getAuthState'
    })
  },
  data () {
    return {
      tabFocus: false
    }
  },
  watch: {
    tabFocus (n) {
      if (!n) {
        return
      }
      this.fetchMe()
    }
  },
  beforeMount () {
    const urlParams = new URLSearchParams(window.location.search)

    if (!urlParams.has('accessToken')) {
      return
    }

    const accessToken = urlParams.get('accessToken')
    this.authLogin({ accessToken })
  },
  mounted () {
    this.fetchMe()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

    window.visualViewport.addEventListener('resize', this.calculateBodyHeight)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.calculateBodyHeight)
    } else {
      document.addEventListener('resize', this.calculateBodyHeight)
    }

    document.addEventListener('click', this.calculateBodyHeight)
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.calculateBodyHeight)
    } else {
      document.removeEventListener('resize', this.calculateBodyHeight)
    }
  },
  methods: {
    adjustChatLayout () {
      this.$store.dispatch('chat/adjustChatLayout')
    },
    ...mapActions({
      sendMessage: 'messages/sendMessage',
      closeChat: 'chat/closeChat',
      fetchMe: 'chat/fetchMe',
      calculateBodyHeight: 'chat/calculateBodyHeight',
      authLogin: 'auth/authLogin'
    }),
    handleVisibilityChange () {
      this.tabFocus = document.visibilityState === 'visible'
      this.calculateBodyHeight()
    }
  }
}
</script>

<style lang="scss">
@import '../assets/css/app';

.v-toast__item {
  min-height: auto;
  .v-toast__text {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    padding: 10px 25px;
  }
}

.chat {
  background: #FFFFFF;
  // box-shadow: 0px 8px 24px rgba(149, 157, 165, 0.2);
  border-radius: 10px;
  // width: 350px;
  font-family: 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
}

.fade-in-up-enter-active {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.fade-in-up-leave-active {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.fade-in-up-enter, .fade-in-up-leave-to {
  opacity: 0;
  transform: translateY(25px);
}
</style>
